import { coralCommentsEdition, initCoralByCommentsBtnEditions } from './fn';
import {
  initCoralComments,
  isCoralCommentsLoaded,
} from '../../../../core/comments/comments';

export function colorScheme() {
  let currentColorScheme = localStorage.getItem('colorScheme');
  let articlePage =
    document.querySelector('.root').id == 'page_index_articles_detail'
      ? true
      : false;

  let setAutoColorModeButton = document.querySelector(
    '.radio-switcher #autocolorscheme',
  );
  let setDarkColorModeButton = document.querySelector(
    '.radio-switcher #darkcolorscheme',
  );
  let setLightColorModeButton = document.querySelector(
    '.radio-switcher #lightcolorscheme',
  );

  let radioButtonsWrapper = document.querySelector(
    '.radio-switcher.radio-switcher_color',
  );

  // let darkmodeIcon = document.querySelector('.icon .darkmode');
  // let lightmodeIcon = document.querySelector('.icon .lightmode');

  if (!window.suggestedColorScheme || window.suggestedColorScheme == 'auto') {
    if (window.prefersDarkScheme.matches) {
      document.body.classList.add('dark-mode');
    }
  } else if (window.suggestedColorScheme == 'dark') {
    document.body.classList.add('dark-mode');
  }

  if (!!radioButtonsWrapper) {
    function listenMediaPrefersColor() {
      if (window.prefersDarkScheme.matches) {
        window.htmlElement.dataset.colorScheme = 'dark';
      } else {
        window.htmlElement.dataset.colorScheme = 'light';
      }

      window.prefersDarkScheme.addEventListener(
        'change',
        listenMediaPrefersColorChangeGlobal,
      );
    }

    //set nec radio to active
    if (!currentColorScheme || currentColorScheme == 'auto') {
      setAutoColorModeButton.classList.add('active-switch');
      radioButtonsWrapper.classList.add('disabled');

      if (window.prefersDarkScheme.matches) {
        setDarkColorModeButton.classList.add('active-switch');
        // lightmodeIcon.classList.add('hide');
      } else {
        setLightColorModeButton.classList.add('active-switch');
        // darkmodeIcon.classList.add('hide');
      }
    } else if (currentColorScheme == 'dark') {
      setDarkColorModeButton.classList.add('active-switch');
      // lightmodeIcon.classList.add('hide');
    } else if (currentColorScheme == 'light') {
      setLightColorModeButton.classList.add('active-switch');
      // darkmodeIcon.classList.add('hide');
    }
    //end of set active radio

    setAutoColorModeButton.addEventListener('click', function () {
      if (!setAutoColorModeButton.classList.contains('active-switch')) {
        setAutoColorModeButton.classList.add('active-switch');
        localStorage.setItem('colorScheme', 'auto');
        radioButtonsWrapper.classList.add('disabled');
      } else {
        setAutoColorModeButton.classList.remove('active-switch');
        radioButtonsWrapper.classList.remove('disabled');
        window.prefersDarkScheme.removeEventListener(
          'change',
          listenMediaPrefersColorChangeGlobal,
        );

        if (window.prefersDarkScheme.matches) {
          localStorage.setItem('colorScheme', 'dark');
          document.body.classList.add('dark-mode');
          gtmDataLayer.push({
            colorMode: 'dark',
          });
          window.postMessage({ __dianomiTheme: { theme: 'dark' } });
        } else {
          localStorage.setItem('colorScheme', 'light');
          document.body.classList.remove('dark-mode');
          gtmDataLayer.push({
            colorMode: 'light',
          });
          window.postMessage({ __dianomiTheme: { theme: 'light' } });
        }
      }

      if (window.prefersDarkScheme.matches) {
        setDarkColorModeButton.classList.add('active-switch');
        setLightColorModeButton.classList.remove('active-switch');
        document.body.classList.add('dark-mode');
        // darkmodeIcon.classList.remove('hide');
        // lightmodeIcon.classList.add('hide');
        gtmDataLayer.push({
          colorMode: 'dark',
        });
        window.postMessage({ __dianomiTheme: { theme: 'dark' } });
      } else {
        setLightColorModeButton.classList.add('active-switch');
        setDarkColorModeButton.classList.remove('active-switch');
        document.body.classList.remove('dark-mode');
        // darkmodeIcon.classList.add('hide');
        // lightmodeIcon.classList.remove('hide');
        gtmDataLayer.push({
          colorMode: 'light',
        });
        window.postMessage({ __dianomiTheme: { theme: 'light' } });
      }

      listenMediaPrefersColor();

      let currentEdition = document.querySelector('body').dataset.edtn;
      if (
        coralCommentsEdition.includes(currentEdition) &&
        isCoralCommentsLoaded()
      ) {
        initCoralComments();
      }
    });

    setDarkColorModeButton.addEventListener('click', function () {
      localStorage.setItem('colorScheme', 'dark');
      document.body.classList.add('dark-mode');
      gtmDataLayer.push({
        colorMode: 'dark',
      });
      window.postMessage({ __dianomiTheme: { theme: 'dark' } });

      setDarkColorModeButton.classList.add('active-switch');

      if (setAutoColorModeButton.classList.contains('active-switch')) {
        setAutoColorModeButton.classList.remove('active-switch');
      }

      if (setLightColorModeButton.classList.contains('active-switch')) {
        setLightColorModeButton.classList.remove('active-switch');
      }

      if (radioButtonsWrapper.classList.contains('disabled')) {
        radioButtonsWrapper.classList.remove('disabled');
      }

      // lightmodeIcon.classList.add('hide');
      // darkmodeIcon.classList.remove('hide');

      if (window.htmlElement.dataset.colorScheme !== 'dark') {
        window.htmlElement.dataset.colorScheme = 'dark';
        window.prefersDarkScheme.removeEventListener(
          'change',
          listenMediaPrefersColorChangeGlobal,
        );
        let currentEdition = document.querySelector('body').dataset.edtn;
        if (
          coralCommentsEdition.includes(currentEdition) &&
          isCoralCommentsLoaded()
        ) {
          initCoralComments();
        }
      } else {
        window.prefersDarkScheme.removeEventListener(
          'change',
          listenMediaPrefersColorChangeGlobal,
        );
      }
    });

    setLightColorModeButton.addEventListener('click', function () {
      localStorage.setItem('colorScheme', 'light');
      document.body.classList.remove('dark-mode');
      gtmDataLayer.push({
        colorMode: 'light',
      });
      window.postMessage({ __dianomiTheme: { theme: 'light' } });

      setLightColorModeButton.classList.add('active-switch');

      if (setAutoColorModeButton.classList.contains('active-switch')) {
        setAutoColorModeButton.classList.remove('active-switch');
      }

      if (setDarkColorModeButton.classList.contains('active-switch')) {
        setDarkColorModeButton.classList.remove('active-switch');
      }

      if (radioButtonsWrapper.classList.contains('disabled')) {
        radioButtonsWrapper.classList.remove('disabled');
      }

      // darkmodeIcon.classList.add('hide');
      // lightmodeIcon.classList.remove('hide');

      if (window.htmlElement.dataset.colorScheme !== 'light') {
        window.htmlElement.dataset.colorScheme = 'light';
        window.prefersDarkScheme.removeEventListener(
          'change',
          listenMediaPrefersColorChangeGlobal,
        );
        let currentEdition = document.querySelector('body').dataset.edtn;
        if (
          coralCommentsEdition.includes(currentEdition) &&
          isCoralCommentsLoaded()
        ) {
          initCoralComments();
        }
      } else {
        window.prefersDarkScheme.removeEventListener(
          'change',
          listenMediaPrefersColorChangeGlobal,
        );
      }
    });
  }
}
